import React, { ComponentProps } from 'react';

import { IconButton } from '@zapier/design-system';

type Props = Omit<ComponentProps<typeof IconButton>, 'color' | 'icon'>;

function MenuMoreToggler(props: Props) {
  return <IconButton {...props} color="icon-tertiary" icon="navMoreHoriz" />;
}

export default MenuMoreToggler;
